import {
  getPropertyNameForIncompleteTimeWindow,
  INCOMPLETE_END_SUFFIX,
  INCOMPLETE_START_SUFFIX,
} from '@modules/charts/components/LineChartWrapper/helpers/getPropertyNameForIncompleteTimeWindow';
import { LineChartDataPoint } from '@modules/charts/types';

export const getDeltaLabelValue = (
  dataPoint: LineChartDataPoint,
  deltaLabel: string,
) => {
  const incompleteStartPeriodDeltaLabel =
    getPropertyNameForIncompleteTimeWindow({
      displayName: deltaLabel,
      incompleteStartEndSuffix: INCOMPLETE_START_SUFFIX,
    });
  const incompleteEndPeriodDeltaLabel = getPropertyNameForIncompleteTimeWindow({
    displayName: deltaLabel,
    incompleteStartEndSuffix: INCOMPLETE_END_SUFFIX,
  });
  return (
    dataPoint[deltaLabel] ||
    dataPoint[incompleteStartPeriodDeltaLabel] ||
    dataPoint[incompleteEndPeriodDeltaLabel]
  );
};
